module.exports = __webpack_public_path__ + "img/bbk.5fc29d3a.png";